const Matrix = ({ surveyQuestionId, statements, answerChoices, responses, saveResponse, compact }) => {

    const rows = statements.length;
    const columns = answerChoices.length;

    const onMatrixRadioChange = (matrixStatementId, matrixAnswerChoiceId) => {
        console.log(`matrixStatementId: ${matrixStatementId} matrixAnswerChoiceId: ${matrixAnswerChoiceId}`);
        const params = {
            surveyQuestionId: surveyQuestionId,
            matrixStatementId: parseInt(matrixStatementId, 10),
            matrixAnswerChoiceId: parseInt(matrixAnswerChoiceId, 10)
        }
        // console.log(params);
        saveResponse(params);
    }

    if (rows && columns) {
        return (
            <div className={`${compact ? "compact" : ""} matrix`}>
                <table className="matrix">
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            {
                                answerChoices.map((answerChoice, i) => {
                                    return (
                                        <th key={`th_surveyQuestionId_${surveyQuestionId}_answerChoice_${i}`}>{answerChoice.text}</th>
                                    )
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            statements.map((statement, i) => {
                                return (
                                    <tr key={`tr_surveyQuestionId_${surveyQuestionId}_statement_${i}`}>
                                        <td>{statement.text}</td>
                                        {
                                            answerChoices.map((answerChoice, j) => {
                                                let checked = false;
                                                for (let response of responses) {
                                                    if ((response.matrixStatementId === statement.matrixStatementId) && (response.matrixAnswerChoiceId === answerChoice.matrixAnswerChoiceId)) {
                                                        checked = true;
                                                        break;
                                                    }
                                                }
                                                return (
                                                    <td key={`td_surveyQuestionId_${surveyQuestionId}_statement_${i}_answerChoice_${j}`}>
                                                        <input type="radio" name={`radio_surveyQuestionId_${surveyQuestionId}_statement_${i}`} checked={checked} onChange={() => onMatrixRadioChange(statement.matrixStatementId, answerChoice.matrixAnswerChoiceId)} />
                                                    </td>
                                                )
                                            })
                                        }
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }
};

export default Matrix;